import React from 'react';
import { motion } from 'framer-motion';
import { Lock, ShieldCheck, CreditCard } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { OfferSelector } from './OfferSelector';
export function FinalCTA() {
  return <section className="py-12 md:py-24 bg-white text-center" data-id="element-118">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-8 md:mb-12" data-id="element-120">
          <div className="text-3xl md:text-4xl mb-4 md:mb-6" data-id="element-121">🧘</div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-gray-900 mb-4 md:mb-6 leading-tight" data-id="element-122">
            El próximo lunes podés volver a improvisar la clase.
            <br data-id="element-123" />
            <span className="text-yoga-purple-600" data-id="element-124">
              O podés entrar al estudio con todo resuelto desde hoy.
            </span>
          </h2>
          <p className="text-xl md:text-2xl font-bold text-gray-500 mb-8 md:mb-12" data-id="element-125">
            ¿Cuánto cuesta NO tenerlo?
          </p>
        </motion.div>

        <div className="mb-8 md:mb-12" data-id="element-126">
          <CountdownTimer data-id="element-127" />
        </div>

        <OfferSelector variant="final" data-id="element-128" />
      </div>
    </section>;
}